export enum BoardExcelFloorErrorEnum {
  FLOOR_MATCH_ERROR = 'FloorMatchError',
  BOARD_TYPE_OBJECT_ERROR = 'BoardTypeObjectError',
  BOARD_TYPE_MAPPING_ERROR = 'BoardTypeMappingError',
  FLOOR_MAPPING_ERROR = 'FloorMappingError',
}
